import { render, staticRenderFns } from "./MiMenu.vue?vue&type=template&id=9bbcc6e2&"
import script from "@/components/MiMenu/MiMenu.ts?vue&type=script&lang=ts&"
export * from "@/components/MiMenu/MiMenu.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VMenu})
